module.exports = __webpack_public_path__ + "static/img/ill3.f4839f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/envi/ill3.png
// module id = i05h
// module chunks = 1